/**
 * Utility functions for ticket management
 */

import { Ticket, WorkNote } from '../../types/ticketTypes';

/**
 * Sort work notes by timestamp (newest first)
 */
export const sortWorkNotes = (workNotes: WorkNote[]): WorkNote[] => {
  return [...workNotes].sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
};

/**
 * Group tickets by assigned technician
 */
export const groupTicketsByAssignee = (tickets: Ticket[]): Record<string, Ticket[]> => {
  return tickets.reduce((groups, ticket) => {
    const assignee = ticket.assignedTo;
    if (!groups[assignee]) {
      groups[assignee] = [];
    }
    groups[assignee].push(ticket);
    return groups;
  }, {} as Record<string, Ticket[]>);
};

/**
 * Sort assignees with current user first, then alphabetically
 */
export const sortAssignees = (assignees: string[], currentUser?: string): string[] => {
  return assignees.sort((a, b) => {
    // If currentUser is specified, put their tickets first
    if (currentUser) {
      if (a === currentUser && b !== currentUser) return -1;
      if (b === currentUser && a !== currentUser) return 1;
    }
    // For all other cases, sort alphabetically
    return a.localeCompare(b);
  });
};

/**
 * Get list of available technicians for appointment assignment
 */
export const getAvailableTechnicians = (tickets: Ticket[]): string[] => {
  const technicians = new Set<string>();
  tickets.forEach(ticket => technicians.add(ticket.assignedTo));
  return Array.from(technicians).sort();
};